var _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFur1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_94_3082",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 0,
    width: 55,
    height: 75
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3335 0H71.9168V74.0156H17.3335V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_94_3082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8281 67.8438C17.8281 71.2448 20.5885 74.0156 23.974 74.0156H65.7708C69.1615 74.0156 71.9167 71.2448 71.9167 67.8438V6.16667C71.9167 2.76563 69.1615 0 65.7708 0H23.974C20.5885 0 17.8281 2.76563 17.8281 6.16667V46.875H20.2865V6.16667C20.2865 4.125 21.9427 2.46875 23.974 2.46875H65.7708C67.8021 2.46875 69.4583 4.125 69.4583 6.16667V67.8438C69.4583 69.8854 67.8021 71.5469 65.7708 71.5469H23.974C21.9427 71.5469 20.2865 69.8854 20.2865 67.8438V57.9792H17.8281V67.8438Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7446 62.9108C22.7446 63.5931 23.2967 64.1452 23.9738 64.1452H65.7707C66.4478 64.1452 66.9998 63.5931 66.9998 62.9108V6.16602C66.9998 5.48372 66.4478 4.93164 65.7707 4.93164H23.9738C23.2967 4.93164 22.7446 5.48372 22.7446 6.16602V46.8744H25.203V7.40039H64.5415V61.6764H25.203V57.9785H22.7446V62.9108Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.729 66.6094H51.0207V69.0781H38.729V66.6094Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_94_3082",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 6,
    width: 9,
    height: 69
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.84912 6.66602H9.3335V74.015H1.84912V6.66602Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_94_3082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.84912 20.9674V70.3112C1.84912 72.3529 3.50537 74.0143 5.53662 74.0143C7.57308 74.0143 9.22412 72.3529 9.22412 70.3112V13.5664C9.22412 13.3789 9.18245 13.1862 9.09912 13.0143L6.64079 8.08203C6.22412 7.24349 4.85433 7.24349 4.43766 8.08203L1.97933 13.0143C1.896 13.1862 1.84912 13.3789 1.84912 13.5664V18.5039H4.30745V13.8581L5.53662 11.3893L6.76579 13.8581V62.9102H4.30745V20.9674H1.84912ZM6.76579 65.3789V70.3112C6.76579 70.9883 6.2137 71.5456 5.53662 71.5456C4.85954 71.5456 4.30745 70.9883 4.30745 70.3112V65.3789H6.76579Z",
    fill: "black"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76546 0H5.5363C4.85921 0 4.30713 0.552083 4.30713 1.23437V2.46875H6.76546V0Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6512 55.5111V53.0423H20.2918C20.0106 53.0423 19.7293 53.0163 19.4637 52.9746L19.0522 55.4069C19.4533 55.4746 19.87 55.5111 20.2866 55.5111H21.6512Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9116 42.291H15.37V44.7025H12.9116V42.291Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9116 8.53711H15.37V10.9486H12.9116V8.53711Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0625 4.625C12.4271 5.16146 12.6771 5.75521 12.8073 6.38542L15.2135 5.88021C15.0156 4.92708 14.6406 4.04167 14.0937 3.23438L12.0625 4.625Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9116 32.6465H15.37V35.0579H12.9116V32.6465Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9116 18.1816H15.37V20.5931H12.9116V18.1816Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9116 13.3594H15.37V15.7708H12.9116V13.3594Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9116 37.4688H15.37V39.8802H12.9116V37.4688Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9116 27.8223H15.37V30.2337H12.9116V27.8223Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9116 23H15.37V25.4115H12.9116V23Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0519 1.2181C11.2446 0.681642 10.3488 0.317058 9.39567 0.134766L8.93213 2.55664C9.56234 2.67643 10.1613 2.92122 10.6978 3.27539L12.0519 1.2181Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0571 53.041H26.4582V55.5098H24.0571V53.041Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.37 47.1152H12.9116V48.11C12.9116 48.6777 12.9793 49.2402 13.1043 49.7923L15.5002 49.235C15.4168 48.8652 15.37 48.4902 15.37 48.11V47.1152Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.37 54.3809L17.6772 52.2923C17.1304 51.9486 16.6616 51.5059 16.2866 50.9746L14.2866 52.4121C14.8491 53.2038 15.5522 53.8652 16.37 54.3809Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0833 16.0358V11.1035C62.0833 10.4212 61.5313 9.86914 60.8542 9.86914H55.9375V12.3327H59.625V16.0358H62.0833Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6616 11.1035V16.0358H30.1252V12.3327H33.8127V9.86914H28.896C28.2137 9.86914 27.6616 10.4212 27.6616 11.1035Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8125 17.2715C33.1302 17.2715 32.5833 17.8236 32.5833 18.5059V20.9694H31.3542C30.6719 20.9694 30.125 21.5215 30.125 22.2038V30.8392C30.125 31.5215 30.6719 32.0736 31.3542 32.0736H58.3958C59.0729 32.0736 59.625 31.5215 59.625 30.8392V22.2038C59.625 21.5215 59.0729 20.9694 58.3958 20.9694H57.1667V18.5059C57.1667 17.8236 56.6146 17.2715 55.9375 17.2715H33.8125ZM35.0417 29.6048H32.5833V23.4382H35.0417V29.6048ZM37.5 27.1413H52.25V29.6048H37.5V27.1413ZM57.1667 29.6048H54.7083V23.4382H57.1667V29.6048ZM53.4792 20.9694C52.7969 20.9694 52.25 21.5215 52.25 22.2038V24.6725H37.5V22.2038C37.5 21.5215 36.9479 20.9694 36.2708 20.9694H35.0417V19.735H54.7083V20.9694H53.4792Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6252 43.1725V38.2402C59.6252 37.5579 59.0731 37.0059 58.396 37.0059H41.1877C40.5054 37.0059 39.9585 37.5579 39.9585 38.2402V43.1725C39.9585 43.8548 40.5054 44.4069 41.1877 44.4069H46.8231L44.0054 47.235L45.745 48.9798L49.7918 44.9173L53.8387 48.9798L55.5783 47.235L52.7554 44.4069H58.396C59.0731 44.4069 59.6252 43.8548 59.6252 43.1725ZM57.1668 41.9434H42.4168V39.4746H57.1668V41.9434Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4688 50.3809C23.4428 50.9018 23.7449 51.3809 24.2241 51.5789L28.7397 53.4487L29.9584 58.1934C30.0886 58.6987 30.5209 59.0632 31.0366 59.1101C31.073 59.1153 31.1147 59.1153 31.1511 59.1153C31.6251 59.1153 32.0574 58.8445 32.2657 58.407L37.3855 47.3966C37.5886 46.9539 37.5157 46.433 37.198 46.0632C36.8803 45.6987 36.3751 45.5528 35.9116 45.6934L24.3334 49.2559C23.8386 49.4122 23.4897 49.8601 23.4688 50.3809ZM33.9845 48.8705L31.4845 54.2455L30.9636 52.2351C30.8699 51.8601 30.6043 51.5476 30.2449 51.4018L28.3282 50.6101L33.9845 48.8705Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFur1);
export default __webpack_public_path__ + "static/media/fur1.faab538eb3cc8660fa9537d6381c337a.svg";
export { ForwardRef as ReactComponent };